import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import React from "react";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";

/**
 * The properties for {@link DeleteExtraRecordDialog}
 */
export type DeleteExtraRecordDialogProps = {
    /** The uuid of the record */
    record: UUID;
    /** Callback function when the Dialog is closed */
    onClose: () => void;
    /** Callback function when the file is deleted */
    onDelete: () => void;
};

/**
 * A dialog for adding a new split dns record
 */
export default function DeleteExtraRecordDialog(props: DeleteExtraRecordDialogProps) {
    const [t] = useTranslation("dialog-delete-extra-record");

    /**
     * Delete the dns
     */
    const deleteDns = async () => {
        await ApiInternal.dns.deleteExtraDnsRecord(props.record);
        props.onDelete();
    };

    return (
        <Dialog onClose={props.onClose} open={true}>
            <DialogTitle>{t("heading.delete-extra-record")}</DialogTitle>
            <DialogActions>
                <Button autoFocus={true} onClick={props.onClose}>
                    {t("button.cancel")}
                </Button>
                <Button color={"red"} onClick={deleteDns}>
                    {t("button.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
